// extracted by mini-css-extract-plugin
module.exports = {"containerLoader":"Loader_containerLoader__1z2Do","loader":"Loader_loader__2DkXo","loading":"Loader_loading__2jIrA"};